import React from 'react'
import PublicDetailsCard from '_public-details-card'

import {
  CONNECTED_COMPANIES,
  CONNECTED_USERS,
  CONNECTED_OPPORTUNITIES,
} from './graph-queries'

const Index = ({ entityId, currentTab }) => {
  const connections = {
    company: {
      gqlQuery: CONNECTED_COMPANIES,
      gqlParams: { id: entityId },
      gqlQueryName: 'getActivityConnectedCompaniesPaged',
      translationKey: 'companies.titleplural',
    },
    people: {
      gqlQuery: CONNECTED_USERS,
      gqlParams: { id: entityId },
      gqlQueryName: 'getActivityConnectedUsersPaged',
      translationKey: 'people.titleplural',
    },
    opportunity: {
      gqlQuery: CONNECTED_OPPORTUNITIES,
      gqlParams: { id: entityId },
      gqlQueryName: 'getActivityConnectedOpportunitiesPaged',
      translationKey: 'opportunities.titleplural',
    },
  }

  return (
    <PublicDetailsCard.ConnectionsPaged
      currentTab={currentTab}
      connections={connections}
      useFollowersLabel={true}
    />
  )
}

export default Index
